import { Modal, Tab, Tabs } from "@mui/material";
import styles from "./styles.module.scss";
import classNames from "classnames";
import CloseIcon from "../../../../assets/images/svg/remove.svg";
import { useState } from "react";
import { DEFAULT_SETTLEMENT_TAB, MANUAL_SETTLEMENT_TAB } from "./constants";
import DefaultSettlement from "./DefaultSettlement";
import ManualSettlement from "./ManualSettlement";
import { useTranslation } from "react-i18next";

interface ISettlementModal {
  open: boolean;
  handleClose: () => void;
}

const SettlementModal = ({ open, handleClose }: ISettlementModal) => {
  const [tabType, setTabType] = useState("default");
  const { t } = useTranslation();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabType(newValue);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={styles.modalContainer}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className={classNames(styles["card"], styles["modal_body"])}>
        <div className={styles["modal_header"]}>
          <h1 className={styles["h1"]}>{t("global_status_settlement")}</h1>
          <img
            src={CloseIcon}
            alt=""
            className={styles["close_icon"]}
            onClick={handleClose}
          />
        </div>
        <div className={styles["tab_container"]}>
          <Tabs
            style={{ alignItems: "center" }}
            className={styles.tab_wrapper}
            value={tabType}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { display: "none" },
            }}>
            <Tab
              value="default"
              label={DEFAULT_SETTLEMENT_TAB}
              className={classNames(
                styles.tab,
                tabType === "default" && styles.tab_selected
              )}
            />
            <Tab
              value="manual"
              label={MANUAL_SETTLEMENT_TAB}
              className={classNames(
                styles.tab,
                tabType === "manual" && styles.tab_selected
              )}
            />
          </Tabs>
        </div>
        {tabType === "default" ? <DefaultSettlement /> : <ManualSettlement />}
      </div>
    </Modal>
  );
};

export default SettlementModal;
